import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const DepartmentModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = React.useRef(false);
    const [name, setName] = useState('');

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [code, setcode] = useState('');
    const optionGroup = [
        {
            label: t('staff'),
            value: '3',
        },
        {
            label: t('manager'),
            value: '2',
        },
        {
            label: t('approval'),
            value: '4',
        },
    ];
    const [valueOption, setValueOption] = useState({
        label: t('staff'),
        value: '3',
    });
    useEffect(() => {
        if (isEdit) {
            setName(dataUpdate.departs_nm);
            setcode(dataUpdate.depart_cd);
            setValueOption({
                label: dataUpdate.group_nm,
                value: dataUpdate.group_user,
            });
        } else {
            setName('');
            setcode('');
            setValueOption({
                label: t('staff'),
                value: '3',
            });
        }
    }, [dataUpdate]);

    const handleEdit = () => {
        if (addCabinetFlag.current === true) return;
        if (!name || !code) return toast.error(t('error.param'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);
        if (!isEdit) {
            let InVal = [name, code, valueOption.value];
            sendRequest(serviceList.createdepartment, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            let InVal = [name, code, dataUpdate.id, valueOption.value];
            sendRequest(serviceList.updatedepartment, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();

            setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            // style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {!isEdit ? t('create_department') : t('update_department')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('name_department')}
                            valueChange={name}
                            getValue={setName}
                            required
                            autoFocus
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput label={t('code_department')} valueChange={code} required getValue={setcode} />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('group_staff')}
                            valueSelect={valueOption}
                            required
                            getValue={setValueOption}
                            selectOption={optionGroup}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default DepartmentModal;
